import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import Footer from "@/components/Footer";
import Header from "@/components/Header";

export default function LegalLayout({ eyebrow, title, updated, children, testId }) {
  return (
    <div data-testid={testId} className="min-h-screen bg-[#050505] text-zinc-100">
      <Header />
      <main className="pt-28 sm:pt-32 pb-24 px-6 lg:px-10">
        <div className="max-w-3xl mx-auto">
          <Link
            to="/"
            data-testid="legal-back-home"
            className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-zinc-500 hover:text-[#C5A059] transition-colors mb-10"
          >
            <ArrowLeft className="w-3.5 h-3.5" />
            Back to home
          </Link>

          <p className="text-xs uppercase tracking-[0.3em] text-[#C5A059] mb-4">{eyebrow}</p>
          <h1 className="font-display text-4xl sm:text-5xl text-white font-light tracking-tight">
            {title}
          </h1>
          {updated && (
            <p className="text-xs uppercase tracking-[0.2em] text-zinc-600 mt-4">
              Last updated: {updated}
            </p>
          )}

          <div className="mt-12 space-y-8 text-zinc-300 leading-relaxed [&_h2]:font-display [&_h2]:text-2xl [&_h2]:text-white [&_h2]:font-normal [&_h2]:mb-3 [&_p]:text-sm [&_p]:text-zinc-400 [&_p]:leading-relaxed [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-2 [&_ul_li]:text-sm [&_ul_li]:text-zinc-400 [&_strong]:text-zinc-200">
            {children}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
